import { atom } from "jotai";

const measureUnitsAtom = atom<any[]>([]);

export { measureUnitsAtom };
